






















































import { Component, Mixins } from "vue-property-decorator";

import MyForm from "@/mixins/form";

import MyConfig from "@/config.ts";

@Component
export default class extends Mixins(MyForm) {
  apiserver: string = MyConfig.casapi;

  headers: any = {
    Authorization: window.localStorage.getItem("token")
  };

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const result = await this.$store.dispatch(
              "workorders/saveVipExcel",
              {
                id: this.editId,
                status: values.status,
                remark: values.remark
              }
            );
            if (result && result.Message && result.Message === "success") {
              this.$message.success("操作成功");
              this.handleCancel();
            } else {
              this.$message.error(result.Message);
            }

            this.confirmLoading = false;
          }
        });
      }
    });
  }

  handleUpload(info: any) {
    // console.log(info)
    if (info.file.status === "done") {
      const res = info.file.response;
      if (parseInt(res.Code, 10) === 200) {
        this.$message.success(`操作成功，导入${res.Data}个数据`);
      } else {
        this.$message.error(res.Message);
      }
    }
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("workorders/getVipExcelDetail", {
      id: this.editId
    });
    if (res && res.Data) {
      this.formData = res.Data;
    }
    this.spinLoading = false;
  }
}
